import axios from 'axios'
import storage from '../utils/storage'
import store from '../store'

// 创建 axios 实例，baseURL 指向后端 API
// 开发环境直连后端，生产环境走 /api/v3（由 nginx 代理）
const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '/api/v3'
const request = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器：自动附加 JWT Token
request.interceptors.request.use(
  config => {
    // 兼容旧 key：优先读 user_real，回退到 user
    let user = storage.get('user_real')
    if (!user || !user.token) {
      user = storage.get('user')
    }
    if (user && user.token) {
      config.headers['Authorization'] = `Bearer ${user.token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器：统一处理错误，兼容 mock 格式 {code,data,message} 和真实后端原始格式
request.interceptors.response.use(
  response => {
    const res = response.data
    // 真实后端直接返回原始数据，包装成前端统一的 {code,data,message}
    if (res && typeof res === 'object' && 'code' in res && 'data' in res) {
      // mock 旧格式
      if (res.code !== 200) {
        console.warn('[API] 业务错误:', res.message || `code=${res.code}`)
        return Promise.reject(new Error(res.message || '请求失败'))
      }
      return res
    }
    return { code: 200, data: res, message: 'success' }
  },
  error => {
    if (error.response) {
      const status = error.response.status
      const data = error.response.data
      const isLoginRequest = error.config && error.config.url && error.config.url.includes('/auth/login')

      // 提取后端返回的具体错误信息
      const detailMessage = data && data.detail ? data.detail : (data && data.message ? data.message : null)

      if (status === 401 && !isLoginRequest) {
        // Token 失效，清除登录态并跳转到登录页（登录请求不跳转）
        store.commit('LOGOUT')
        window.location.href = '/#/login'
      }

      console.error('[API] HTTP 错误:', status, data)

      // 用后端具体错误信息替换通用 HTTP 错误消息
      if (detailMessage) {
        error.message = detailMessage
      }
    } else {
      console.error('[API] 网络错误:', error.message)
    }
    return Promise.reject(error)
  }
)

export default request
